var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    rx: 16,
    fill: "#014C8D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3459 36.5091H26.8863L24.5329 38.5181L22.1794 36.5091H17.2222V37.8867C17.2222 39.6426 18.4351 41.0731 19.935 41.1012C20.0745 41.9691 20.412 42.7532 20.92 43.3668C21.6714 44.2744 22.7638 44.7749 23.9956 44.7749H31.5726C32.8044 44.7749 33.8968 44.2744 34.6481 43.3657C35.1561 42.7521 35.4937 41.968 35.6332 41.1001C36.4299 41.0857 37.1457 40.6753 37.6422 40.0307C38.1059 39.4127 38.3533 38.6593 38.3459 37.8867V36.5091Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3309 34.6722L24.5311 36.2904L26.7509 34.6722H38.3459V34.213C38.3453 33.6839 38.1623 33.1712 37.8277 32.7613C37.4931 32.3514 37.0274 32.0695 36.5091 31.9629C36.462 30.2586 35.7629 28.8322 34.4708 27.83C33.2757 26.8978 31.6788 26.4064 29.8505 26.4064H25.7176C21.8017 26.4064 19.1492 28.6319 19.0591 31.9629C18.5408 32.0695 18.0751 32.3514 17.7405 32.7613C17.4059 33.1712 17.2229 33.6839 17.2222 34.213V34.6722H22.3309Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8852 21.8143H38.6037L39.1157 19.7674L41.6752 18.8869L41.1012 17.2222L37.5423 18.3703L36.7106 21.8143H28.2433V23.6512H29.3196L29.4263 24.5696H29.8505C32.0892 24.5696 34.0787 25.1953 35.5976 26.3789C36.4424 27.0298 37.1272 27.8653 37.5997 28.8213C37.8909 29.4145 38.0982 30.0452 38.2156 30.6955C39.071 31.2221 39.7053 32.0422 39.9999 33.0025C40.2945 33.9628 40.2294 34.9976 39.8166 35.9133C40.0584 36.5431 40.1826 37.2121 40.1828 37.8867C40.1828 39.1691 39.7465 40.3912 38.9544 41.328C38.4642 41.912 37.8363 42.3647 37.1273 42.6453C36.8857 43.3338 36.5258 43.9749 36.0637 44.5396C35.9959 44.6211 35.9265 44.7009 35.8553 44.7778H40.1828C41.1012 44.7778 41.503 44.3186 41.6178 43.4576L43.7072 23.6541H44.7749V21.8143H42.8852Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnack);
export default __webpack_public_path__ + "static/media/snack.314b4ca00f22187fa9ce920fee311e3d.svg";
export { ForwardRef as ReactComponent };